import * as yup from 'yup';

export const employeeSchema = yup.object().shape({
  fname: yup.string().required(),
  lname:yup.string().required(),
  gender: yup.string().required(),
  dob: yup.string().required(),
  maritalStatus: yup.string().required(),
  bloodGroup: yup.string().required(),
  nationality: yup.string().required(),
  empCode:yup.string().required(),
  // religion: yup.string().required(),

  officialEmail: yup.string().required(),
  personalEmail: yup.string().required(),
  mobileNumber: yup.string().required(),
  altContact: yup.string().required(),
  presentAddress: yup.string().required(),
  permanentAddress: yup.string().required(),
  city: yup.string().required(),
  state: yup.string().required(),
  country: yup.string().required(),
  pinCode: yup.string().required(),

  department: yup.string().required(),
  designation: yup.string().required(),
  employmentType: yup.string().required(),
  workMode: yup.string().required(),
  dateOfJoining: yup.string().required(),
  confirmationDate: yup.string().required(),
  manager: yup.string().required(),

  shiftName: yup.string().required(),
  attendanceMode: yup.string().required(),
  biometricId: yup.string().required(),
  weeklyOffDays: yup.string().required(),

  ctc: yup
    .number()
    .typeError('CTC must be a number')
    .min(1000, 'CTC must be at least ₹1,000')
    .required('CTC is required'),

  paymentMode: yup
    .string()
    .oneOf(['Cash', 'Bank Transfer', 'Cheque'], 'Invalid payment mode')
    .required('Payment mode is required'),

  bankDetails: yup.object().shape({
    bankName: yup.string().required('Bank name is required'),
    accountNumber: yup
      .string()
      .matches(/^[0-9]{9,18}$/, 'Account number must be 9–18 digits')
      .required('Account number is required'),
    ifsc: yup
      .string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format')
      .required('IFSC code is required'),
  }),

  pan: yup
    .string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format (e.g., ABCDE1234F)')
    .required('PAN number is required'),

  aadhaar: yup
    .string()
    .matches(/^[2-9]{1}[0-9]{11}$/, 'Invalid Aadhaar number format')
    .required('Aadhaar number is required'),
  
  // profilePhoto:yup.mixed(),
  // documents: yup.object({
  //   bankAccountDocument:yup.mixed().required(),
  //   resume: yup.mixed().required(),
  //   panCard: yup.object({
  //     file: yup.mixed().required(),
  //     verified: yup.boolean().required(),
  //   }),
  //   aadhaarCard: yup.object({
  //     file: yup.mixed().required(),
  //     verified: yup.boolean().required(),
  //   }),
  //   panCard:yup.string().required(),
  //   aadhaarCard:yup.string().required(),
  //   offerLetter: yup.string().required(),
  // }),

  skills: yup.string().required(),
  certifications: yup.string().required(),

  experience: yup.object({
    totalYears: yup.number().required(),
    relevantYears: yup.number().required(),
  }),

  laptopSerial: yup.string().required(),
  vpnInstalled: yup.boolean().required(),

  emergencyContact: yup.object({
    name: yup.string().required(),
    number: yup.string().required(),
    relationship: yup.string().required(),
  }),
  password:yup.string().required(),
  confirmPassword:yup.string().required(),
});
